// extracted by mini-css-extract-plugin
export default {"container":"FreeResponseBody_container__mEPmA","textarea":"FreeResponseBody_textarea__bGwya","submitButton":"FreeResponseBody_submitButton__SJJkP"};